import { render } from "./BottomListEmojiView.vue?vue&type=template&id=5e37a354&scoped=true"
import script from "./BottomListEmojiView.vue?vue&type=script&lang=js"
export * from "./BottomListEmojiView.vue?vue&type=script&lang=js"

import "./BottomListEmojiView.vue?vue&type=style&index=0&id=5e37a354&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e37a354"]])

export default __exports__